/* eslint-disable jsx-a11y/no-distracting-elements */
import AddIcon from '@mui/icons-material/Add';
import LogoutIcon from '@mui/icons-material/Logout';
import {
  Avatar,
  Box,
  Button,
  ClickAwayListener,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material';
import { Container } from '@mui/system';
import commaNumber from 'comma-number';
import React, { useEffect, useState } from 'react';
import { GiTwoCoins } from 'react-icons/gi';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import useAuthentication from '../../hooks/useAuthentication';
import balanceIcon from '../../images/balance.png';
import Logo from '../../images/logo/logo.png';
import './Header.css';
import axios from 'axios';

const Header = () => {
  const location = useLocation();
  const user = secureLocalStorage.getItem('user-info');
  console.log(user);
  const uid = user?.uid;
  const apiUrl = 'https://api-b2b.fasttracktourism.com';
  const apiEndpoint = '/agent/notice/all';
  const { logout } = useAuthentication();
  const navigate = useNavigate();
  const [balance, setBalance] = useState(null);
  const [marqueText, setMarqueText] = useState('');
  // todo: for mobile device
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  useEffect(() => {
    const url = `https://api-b2b.businesssolutions.ae/agent/myaccount/${uid}`;
    const config = {
      method: 'GET',
      header: {
        'content-type': 'application/json',
        accept: 'application/json',
      },
    };
    fetch(url, config)
      .then((res) => res.json())
      .then((data) => {
        setBalance(data);
        if (data?.status !== 'active') {
          logout();
        }
      })
      .catch((err) => console.log(err.message));

    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}${apiEndpoint}`);
        setMarqueText(response.data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [uid]);

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const handleClickAway = () => {};

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box
        sx={{
          position: 'relative',
          overflowX: 'hidden',
          py: 1,
          boxShadow:
            '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
        }}
      >
        <Container>
          <Box
            sx={{
              height: 'fit-content',
              width: '100%',
              alignItems: 'center',
              display: { xs: 'none', sm: 'none', md: 'flex' },
            }}
          >
            {/* //todo:Logo  */}
            <Box
              sx={{
                width: { md: '15%', sm: '50%', xs: '50%' },
                background: 'var(--white)',
                height: '100%',
                display: 'flex',
                justifyContent: {
                  lg: 'start',
                  md: 'start',
                  sm: 'center',
                  xs: 'center',
                },
                alignItems: 'center',
                cursor: 'pointer',
              }}
              onClick={() => navigate('/user/dashboard')}
            >
              <Box
                sx={{
                  height: '80px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <img
                  src={Logo}
                  alt="logo"
                  style={{
                    height: '100%',
                  }}
                />
              </Box>
            </Box>

            <Box
              sx={{
                width: '85%',
                height: '60px',
                display: { md: 'flex', sm: 'none', xs: 'none' },
                alignItems: 'center',
                justifyContent: 'end',
                gap: '10px',
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  background: '#ddd',
                  height: '35px',
                  borderRadius: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  px: 2,
                  color: 'var(--black)',
                  fontSize: 12,
                  fontWeight: 500,
                }}
              >
                <img src={balanceIcon} alt="balance" width="18px" />
                <Box pt={0.2}>
                  <Tooltip
                    title={
                      <>
                        <Box>
                          Main Balance: {commaNumber(balance?.balance || 0)} AED
                        </Box>
                        <Box>
                          Credit Balance: {commaNumber(balance?.credit || 0)}{' '}
                          AED
                        </Box>
                      </>
                    }
                  >
                    {balance?.balance > 0 ? (
                      <span
                        style={{ color: 'var(--green)', fontWeight: '500' }}
                      >
                        {commaNumber(balance?.balance || 0)} AED
                      </span>
                    ) : (
                      <span style={{ color: 'var(--red)', fontWeight: '500' }}>
                        {commaNumber(balance?.balance || 0)} AED
                      </span>
                    )}
                  </Tooltip>
                </Box>
              </Box>
            </Box>
            {/* //todo:Normal Mobile Navbar */}
            <Box
              sx={{
                width: '80%',
                height: '60px',
                display: { md: 'none', sm: 'flex', xs: 'flex' },
                justifyContent: 'end',
                alignItems: 'center',
              }}
            >
              <Tooltip title="Open Menu">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                  <Avatar>
                    {/* {user?.user?.name[0].toUpperCase() || ""} */}TF
                  </Avatar>
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                <MenuItem onClick={handleCloseUserMenu}>
                  <Box
                    sx={{
                      color: 'var(--secondary-color)',
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      fontSize: '17px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: '5px',
                    }}
                  >
                    {parseInt(balance?.credit) > parseInt(balance?.balance) ? (
                      <Tooltip
                        title={
                          <>
                            <Box>
                              Credit Balance:{' '}
                              {commaNumber(balance?.credit || 0)} AED
                            </Box>
                            <Box>
                              Main Balance: {commaNumber(balance?.balance || 0)}{' '}
                              AED
                            </Box>
                          </>
                        }
                      >
                        <span
                          style={{ color: 'var(--red)', fontWeight: '500' }}
                        >
                          -{commaNumber(balance?.credit || 0)} AED
                        </span>
                      </Tooltip>
                    ) : (
                      <Tooltip
                        title={
                          <>
                            <Box>
                              Main Balance: {commaNumber(balance?.balance || 0)}{' '}
                              AED
                            </Box>
                            <Box>
                              Credit Balance:{' '}
                              {commaNumber(balance?.credit || 0)} AED
                            </Box>
                          </>
                        }
                      >
                        <span
                          style={{
                            color: 'var(--secondary-color)',
                            fontWeight: '500',
                          }}
                        >
                          {commaNumber(balance?.balance || 0)} AED
                        </span>
                      </Tooltip>
                    )}
                    <NavLink
                      to="/adddeposite"
                      style={{
                        color: 'var(--secondary-color)',
                        cursor: 'pointer',
                      }}
                    >
                      <Tooltip title="Add Money">
                        <AddIcon style={{ fontSize: '30px' }} />
                      </Tooltip>
                    </NavLink>
                  </Box>
                </MenuItem>
                <MenuItem onClick={handleCloseUserMenu}>
                  <Button
                    style={{
                      background: 'var(--mateBlack)',
                      color: 'var(--white)',
                      fontWeight: 400,
                      padding: '10px',
                      cursor: 'pointer',
                      width: '100%',
                      zIndex: '999',
                    }}
                    onClick={() => {
                      logout();
                    }}
                  >
                    <LogoutIcon />
                    Logout
                  </Button>
                </MenuItem>
              </Menu>
            </Box>
          </Box>
          {(location.pathname === '/user/dashboard' ||
            location.pathname === '/user/home') && (
            <Box
              sx={{
                overflowX: 'hidden',
                display: { xs: 'none', md: 'block' },
              }}
            >
              <marquee
                style={{
                  background: 'var(--secondary-color)',
                  color: 'var(--white)',
                  padding: '6px 0',
                  margin: '10px 0px 0px',
                  borderRadius: '20px',
                  fontSize: '14px',
                }}
              >
                {marqueText && marqueText?.map((item) => item.notice)}
              </marquee>
            </Box>
          )}
        </Container>
      </Box>
    </ClickAwayListener>
  );
};

export default Header;
